import { Box, Card, Button, Modal, Text } from '@nimbus-ds/components';
import { SubmitButton } from 'commons/components';
import { dateFormat, Format } from 'commons/utils/date';
import { useShouldScheduleDowngrade } from 'domains/Billing/BillingPlans/hooks';
import useTranslationBilling from 'domains/Billing/useTranslationBilling';
import { ChangePlanModalProps } from '../../ChangePlanModal';
import PlanChangeVisual from '../PlanChangeVisual';

export default function DowngradePlanModal({
  show,
  onConfirm,
  onCancel,
  disableConfirm,
  currentPlan,
  newPlan,
}: Readonly<ChangePlanModalProps & { disableConfirm: boolean }>) {
  const t = useTranslationBilling('billingPlansPage.changePlanModal');
  const { shouldScheduleDowngrade, downgradeDate } =
    useShouldScheduleDowngrade();

  if (!newPlan || !currentPlan) return null;

  return (
    <Modal open={show} onDismiss={onCancel}>
      <Modal.Header
        title={t('downgrade.title', { newPlanName: newPlan.name })}
      />
      <Modal.Body padding="none">
        <Box display="flex" flexDirection="column" gap="4">
          {shouldScheduleDowngrade && downgradeDate ? (
            <Text>
              {t('downgrade.scheduled.message', {
                newPlanName: newPlan.name,
                expirationDate: dateFormat(downgradeDate, Format.DD_MM),
              })}
            </Text>
          ) : (
            <Text>
              {t('downgrade.message', {
                newPlanName: newPlan.name,
              })}
            </Text>
          )}
          <Card>
            <PlanChangeVisual firstPlan={currentPlan} secondPlan={newPlan} />
          </Card>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCancel}>{t('cancel')}</Button>
        <SubmitButton isLoading={disableConfirm} onClick={onConfirm}>
          {t('downgrade.confirm')}
        </SubmitButton>
      </Modal.Footer>
    </Modal>
  );
}
